import { connectivityService } from '~/data/connectivity/ConnectivityService';

export function assertOnlineForRemote(): void {
  if (!connectivityService.isOnline()) {
    throw new Error('offline');
  }
}
